/** @format */

import React from "react"
import okIMG from "../../../../ebusHomePics/ok.svg"
import { NavLink } from "react-router-dom"

export default () => {
  return (
    <div
      className="d-flex flex-column p-5 align-items-center justify-content-center mx-auto w-75"
      style={{ minHeight: "30rem", gap: 36 }}
    >
      <img src={okIMG} />
      <h5>
        <b>اطلاعات شما با موفقیت ثبت شد</b>
      </h5>
      <h6 style={{ lineHeight: "35px" }}>
        نتیجه, بعد از بررسی های تیم ایباس از طریق پیامک به شما اطلاع داده خواهد
        شد <br />
        از صبوری و همکاری شما سپاسگذاریم
      </h6>
      <NavLink to="/">
        <button
          style={{
            height: "4rem",
            backgroundColor: "#6dd06d",
            borderRadius: "13px",
            color: "#fff",
          }}
          className="btn"
        >
          بازگشت به صفحه اصلی
        </button>
      </NavLink>
    </div>
  )
}
